import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { FileUploadModalComponent } from '../components/file-upload-modal/file-upload-modal.component';

@Injectable({
  providedIn: 'root'
})
export class FileUploadModalService {

  fileUploadModal;
  public modalObserver = new BehaviorSubject(false);
  constructor(public dialog: MatDialog) { }

  public filesDropped(files: any): void {
    console.log('filesDropped called');
    console.log('this.fileUploadModal:', this.fileUploadModal);
    console.log('getState:', this.fileUploadModal ? this.fileUploadModal.getState() : 'null');

    if(this.fileUploadModal && this.fileUploadModal.getState() === 0){
      // Modal is already open, append files
      console.log('Appending files to existing modal');
      this.fileUploadModal.componentInstance.onFilesDragged(files);
    }else{
      // Modal is closed or doesn't exist, open new modal
      console.log('Opening new modal');
      this.fileUploadModal = this.dialog.open(FileUploadModalComponent, {
        width: '70vw',
        maxHeight: '90vh',
        data: files
      });

      this.fileUploadModal.afterClosed().subscribe((_: any) => {
        this.modalObserver.next(true);
        this.fileUploadModal = null;
      });
      this.fileUploadModal.backdropClick().subscribe((_: any) => {
        this.modalObserver.next(true);
      });
    }
  }
}
